import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useSignupContext } from 'packages/signup/components/signupProvider';
import type { TofuSurveyQuestionsValues } from './TofuSurvey';

export default function TofuSurveyFormObserver() {
  const { values } = useFormikContext<TofuSurveyQuestionsValues>();
  const {
    setNumberEmployeesSegmentationComplete,
    setPrevPayrollProviderComplete,
    setIndustryIdentificationComplete,
    setIntentStepComplete,
    numberEmployeesSegmentation,
    prevPayrollProvider,
    industryIdentification,
    intentStep,
  } = useSignupContext();

  useEffect(() => {
    if (
      values.numberEmployeesSegmentation &&
      values.numberEmployeesSegmentation !== numberEmployeesSegmentation
    ) {
      setNumberEmployeesSegmentationComplete(values.numberEmployeesSegmentation);
    } else if (values.prevPayrollProvider && values.prevPayrollProvider !== prevPayrollProvider) {
      setPrevPayrollProviderComplete(values.prevPayrollProvider);
    } else if (
      values.industryIdentification &&
      values.industryIdentification !== industryIdentification
    ) {
      setIndustryIdentificationComplete(values.industryIdentification);
    } else if (values.intentStep && values.intentStep !== intentStep) {
      setIntentStepComplete(values.intentStep);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);
  return null;
}
